import * as actionTypes from 'constants/ActionTypes';

export function getStatisticsVesselPositions(from, until) {
    return {
        type: actionTypes.GET_STATISTICS_VESSEL_POSITIONS.REQUEST,
        from,
        until,
    };
}



// WEBPACK FOOTER //
// ./app/actions/statistics/vesselPositions.js